import * as angular from 'angular';

import { BadActorsWidgetBase, IBadActorsWidgetOptions, IBadActorsWidget } from './badActorsWidgetBase';
import { IWidgetConfiguration } from '..//models';
import { tagDefaultState } from '../../common/';
import { IInputValuesService } from '../../services';

export class BadActorsInvalidPrecedentsWidget extends BadActorsWidgetBase implements IBadActorsWidget {
    configuration: any;
    highlights = ['A bar chart with precedents of invalid KPIs'];
    options: IBadActorsWidgetOptions;
    name = 'Precedents of invalid KPIs - Most frequent issues';
    type = 'badActorsInvalidPrecedents';

    constructor(private _$state: angular.ui.IStateService,
        private _inputValuesService: IInputValuesService,
        config?: IWidgetConfiguration
    ) {
        super(config);
        this.options = {
            seriesClick: (d, i) => {
                this._$state.go(tagDefaultState, { tagDefinitionGuid: d.guid });
            }
        };
        this.configuration = {
            labels: []
        };
    }

    readData(guid?: string): angular.IPromise<any> {
        return this._inputValuesService.getNumberOfInvalidPrecedents(guid);
    }
}